<template>
    <div>
        <p class="mb-xl">Please select the products for this job from the drop-down lists below. To manage products in the drop-down lists go to <a href="/account/products" class="link">Favourite Products</a></p>

        <!-- Passing in shortlist here to keep validation consistent with rest of form -->
        <SystemCRUD :systems="$v.systems" />
        <PVModuleShortlist :shortlist="$v.shortlist" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators'

import PVModuleShortlist from '@/jobs/new/PVModuleShortlist';
import SystemCRUD from '@/jobs/new/SystemCRUD';

export default {
    components: {
        PVModuleShortlist,
        SystemCRUD,
    },

    mixins: [validationMixin],

    validations: {
        shortlist: {
            $each: {
                id: {
                    required
                },
                panel: {
                    required
                }
            }
        },
        systems: {
            $each: {
                id: {
                    required
                },
                inverter: {
                    required
                },
            }
        }
    },

    computed: {
        ...mapState('products', ['shortlist']),
        ...mapGetters('configuration', { systems: 'sorted' }),
    },

    created() {
        this.fetchProducts();
    },

    methods: {
        ...mapActions('products', ['fetchProducts']),
    }
};
</script>
